export class ProductDetailScreenModel {
    /** 商品のID */
    productId: string | null = null;

    /** プレビュー or Not */
    isPreview: string | null | undefined = undefined;
}
